export default {
  namespaced: true,
  state: {
    selectedTag1: [],
    selectedTag2: [],
    isTagFilterActive: false,
    isCommentFilterActive: false,
    returnNotificationId: null,
    returnNotificationDate: null,
  },
  mutations: {
    setSelectedTag1(state, tags) {
      state.selectedTag1 = tags
    },
    setSelectedTag2(state, tags) {
      state.selectedTag2 = tags
    },
    setIsTagFilterActive(state, value) {
      state.isTagFilterActive = value
    },
    setIsCommentFilterActive(state, value) {
      state.isCommentFilterActive = value
    },
    setReturnNotification(state, { id, date }) {
      state.returnNotificationId = id
      state.returnNotificationDate = date
    },
    clearReturnNotification(state) {
      state.returnNotificationId = null
      state.returnNotificationDate = null
    },
    resetFilters(state) {
      state.isTagFilterActive = false
      state.isCommentFilterActive = false
    },
  },
}
